import { Box, Button, IconButton, SwipeableDrawer } from '@mui/material'
import React, { useState } from 'react'
import { Add, Edit, Delete, Check, Close } from '@mui/icons-material';
import { useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CloseIcon from '@mui/icons-material/Close';
import PrintIcon from '@mui/icons-material/Print';
import { showConfirmSweetAlert } from 'hooks/useSweetAlert';
// import { useState } from 'react';

const QuickViewDrawer = (props) => {


    const [currentNoteIndex, setCurrentNoteIndex] = useState(0);
    const [savingNoteIndex, setSavingNoteIndex] = useState(0);
    const [incomeNoteIndex, setIncomeNoteIndex] = useState(0);
    const [estateNoteIndex, setEstateNoteIndex] = useState(0);

    const [clientNotes, setClientNotes] = useState([]);
    const [savingNotes, setSavingNotes] = useState([]);
    const [incomeNotes, setIncomeNotes] = useState([]);
    const [estateNotes, setEstateNotes] = useState([]);

    const [investmentDetails, setInvestmentDetails] = useState([]);
    const [selectedFile, setSelectedFile] = useState(null);

    // Define other state variables for savingPlanNotes, incomePlanNotes, estatePlanNotes, etc.
    const fetchClientNotes = () => {
        // setClientNotes([
        //     {
        //         id: 1,
        //         note: "Test - 01",
        //         date: '2021-03-21'
        //     }
        // ])
        setCurrentNoteIndex(-1)
    }


    const handleDocumentChange = (event) => {
        // upload file at backend side using API or services.....
        setSelectedFile(event.target.files[0]);
    };

    const addNote = (msgType) => {

        if (msgType === 1) {

            let lastIndexId = clientNotes.length - 1;

            let lastId = lastIndexId >= 0 ? clientNotes[lastIndexId].id : 0;

            // todo:: remove length + 1 and make it 0, after integrate with api
            let item = { id: clientNotes.length + 1, note: '', date: '' }

            if (lastId > 0 || clientNotes.length === 0) {
                setClientNotes([...clientNotes, item]);
            }

            setCurrentNoteIndex(clientNotes.length);

        } else if (msgType === 2) {
            const lastIndexId = savingNotes.length - 1;

            const lastId = lastIndexId >= 0 ? savingNotes[lastIndexId].id : 0;

            let item = { id: savingNotes.length + 1, note: '', date: '' }

            if (lastId > 0 || savingNotes.length === 0) {
                setSavingNotes([...savingNotes, item]);
            }

            setSavingNoteIndex(savingNotes.length);


        } else if (msgType === 3) {
            const lastIndexId = incomeNotes.length - 1;

            const lastId = lastIndexId >= 0 ? incomeNotes[lastIndexId].id : 0;

            let item = { id: incomeNotes.length + 1, note: '', date: '' }

            if (lastId > 0 || incomeNotes.length === 0) {
                setIncomeNotes([...incomeNotes, item]);
            }

            setIncomeNoteIndex(incomeNotes.length);

        } else if (msgType === 4) {
            const lastIndexId = estateNotes.length - 1;

            const lastId = lastIndexId >= 0 ? estateNotes[lastIndexId].id : 0;

            let item = { id: estateNotes.length + 1, note: '', date: '' }

            if (lastId > 0 || estateNotes.length === 0) {
                setEstateNotes([...estateNotes, item]);
            }

            setEstateNoteIndex(estateNotes.length);

        }
    };

    const deleteNoteData = async (noteIndex, noteId, msgType) => {

        // > 1 for sure, when integrate with api
        if (noteId > 0) {
            const result = await showConfirmSweetAlert({
                title: 'Delete Item?',
                text: 'Are you sure you want to delete this note?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, delete it!',
                cancelButtonText: 'No, cancel!',
            });

            if (result.isConfirmed) {

                // Implement your delete logic here (possibly using a service or API)

                const filterOption = [...clientNotes]; //copy users data to filtered data for removeUser
                filterOption.splice(noteIndex, 1)
                setClientNotes(filterOption);
            }
        } else {
            // Implement your delete logic here for different msgType and state variables
        }

        setCurrentNoteIndex(-1);
        // Reset other note indices as well
    };


    const editNote = (activeIndex, msgType) => {
        const updateFunctions = {
            1: setCurrentNoteIndex,
            2: setSavingNoteIndex,
            3: setIncomeNoteIndex,
            4: setEstateNoteIndex,
        };

        const updateFunction = updateFunctions[msgType];

        if (updateFunction) {
            updateFunction(activeIndex);
        }
    };

    const updateNote = (activeIndex, msgType) => {
        let noteData;
        let notesArray;
        let noteType;

        switch (msgType) {
            case 1:
                notesArray = clientNotes;
                noteType = "client";
                break;
            case 2:
                notesArray = savingNotes;
                noteType = "saving";
                break;
            case 3:
                notesArray = incomeNotes;
                noteType = "income";
                break;
            case 4:
                notesArray = estateNotes;
                noteType = "estate";
                break;
            default:
                return; // Invalid msgType
        }

        noteData = notesArray[activeIndex];
        const { note, id } = noteData;

        if (!note || note === "") {
            const notifyArray = ["Please enter details."];
            const notificationArray = [{ type: "error", data: notifyArray }];
            toast.error(notifyArray[0]);
        } else {
            const action = id > 0 ? "update" : "add";
            const confirmMsg = window.confirm(`Are you sure you want to ${action} this ${noteType} note?`);

            if (confirmMsg) {
                // Implement your update logic here using services or APIs
            }
        }

        // Reset active indices
        setCurrentNoteIndex(-1);
        setSavingNoteIndex(-1);
        setIncomeNoteIndex(-1);
        setEstateNoteIndex(-1);
    };


    function InvestmentComponent() {
        return (
            <div className="col-lg-12 col-md-12 col-sm-12 padding-top60px">
                <div className='text-capitalize font20px'>Investments</div>
                <div className="quick-view-table padding-top10px bottom20px quickview_i_table">
                    <table className="width100 table-rounded">
                        <thead>
                            <tr>
                                <th className="all_padding10px text-center width50px font14px font-weight400px black-text-1">Account Type</th>
                                <th className="all_padding10px text-center width50px font14px font-weight400px black-text-1">Book Value</th>
                                <th className="all_padding10px text-center width50px font14px font-weight400px black-text-1">Market value</th>
                                <th className="all_padding10px text-center width50px font14px font-weight400px black-text-1">Risk Profile</th>
                                <th className="all_padding10px text-center width50px font14px font-weight400px black-text-1">Gain/Loss</th>
                            </tr>
                        </thead>
                        {/* make it for even off */}
                        <tbody className="quick_sub_table">
                            <tr>
                                <td className="text-left border-none-all blue_clr_important"></td>
                                <td className="text-center border-none-all print_blue_color">$0.025 </td>
                                <td className="text-center border-none-all print_blue_color">$12</td>
                                <td className="text-center border-none-all print_blue_color">Balanced</td>
                                <td className="text-center border-none-all print_blue_color">$2.00</td>
                                {/* gain for green color and red for loss */}
                            </tr>
                            {/* {investmentDetails.length == '' ? investmentDetails.map(data => (
                                <tr key={data.id}>
                                    <td className="text-left border-none-all blue_clr_important"></td>
                                    <td className="text-center border-none-all print_blue_color">$0.025 </td>
                                    <td className="text-center border-none-all print_blue_color">$12</td>
                                    <td className="text-center border-none-all print_blue_color">Balanced</td>
                                </tr>
                            )) :
                                <tr>
                                    <td colSpan={5}>No record to show.</td>
                                </tr>
                            } */}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }

    function OutSideAssetComponent() {
        return (
            <div className="col-lg-12 col-md-12 col-sm-12 padding-top60px">

                <div className='text-capitalize font20px'>Outside Assets</div>

                <div className="quick-view-table padding-top10px bottom20px quickview_i_table">
                    <table className="width100 table-rounded">
                        <thead>
                            <tr>
                                <th className="all_padding10px text-center width50px font14px font-weight400px black-text-1">Asset Name	</th>
                                <th className="all_padding10px text-center width50px font14px font-weight400px black-text-1">Institution</th>
                                <th className="all_padding10px text-center width50px font14px font-weight400px black-text-1">Value</th>
                                <th className="all_padding10px text-center width50px font14px font-weight400px black-text-1">Mortgage</th>
                                <th className="all_padding10px text-center width50px font14px font-weight400px black-text-1">Monthly</th>
                            </tr>
                        </thead>
                        <tbody className="quick_sub_table">
                            <tr>
                                <td className="text-left border-none-all blue_clr_important"></td>
                                <td className="text-center border-none-all print_blue_color">$0.025 </td>
                                <td className="text-center border-none-all print_blue_color">$12</td>
                                <td className="text-center border-none-all print_blue_color">Balanced</td>
                                <td className="text-center border-none-all print_blue_color">$2.00</td>
                                {/* gain for green color and red for loss */}
                            </tr>
                            {/* {investmentDetails.length == '' ? investmentDetails.map(data => (
                                <tr key={data.id}>
                                    <td className="text-left border-none-all blue_clr_important"></td>
                                    <td className="text-center border-none-all print_blue_color">$0.025 </td>
                                    <td className="text-center border-none-all print_blue_color">$12</td>
                                    <td className="text-center border-none-all print_blue_color">Balanced</td>
                                </tr>
                            )) :
                                <tr>
                                    <td colSpan={5}>No record to show.</td>
                                </tr>
                            } */}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }

    function AccountDocComponent() {
        return (
            <>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', p: 1, bgcolor: 'transparent', borderRadius: 1, padding: 0, mt: 5 }} >
                    <div className='text-capitalize font20px'>Account Docs</div>
                    {/* <div>
                        <input className="upload btn-green" type="file" name="uploadDocument" id="uploadDocument" placeholder="Upload file" accept=".jpg,.jpeg,.png,.pdf,.csv,.docx,.doc,.xls,.xlm,.xlsx,.xlsm" />
                    </div> */}

                    <div className="fileUpload btn-green">
                        <span>Add Doc</span>
                        <input
                            className="upload"
                            type="file"
                            name="uploadDocument"
                            id="uploadDocument"
                            onChange={handleDocumentChange}
                            placeholder="Upload file"
                            title={selectedFile && selectedFile.name}
                            accept=".jpg,.jpeg,.png,.pdf,.csv,.docx,.doc,.xls,.xlm,.xlsx,.xlsm"
                        />
                        {/* {selectedFile && <p>Selected file: {selectedFile.name}</p>} */}
                    </div>
                </Box>

                {/*------------------DOCS TABLE ---------------*/}
                <div className="col-lg-12 col-md-12 col-sm-12">
                    <div className="quick-view-table padding-top5px bottom20px">
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="quick-view-table padding-top5px bottom20px">
                                <table striped='true' bordered='true' hover='true' className='width100'>
                                    <thead>
                                        <tr>
                                            <th className='width80'> <div className='font14px font-weight400px black-text-1'>File Name</div> </th>
                                            <th className="text-center"><div className='width50px'></div></th>
                                            <th className="text-center"><div className='width50px font14px font-weight400px black-text-1'>Action</div></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td colSpan={3} className='padding10px'>No record to show.</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }

    function PlanningModuleComponent() {
        return (
            <div className="col-lg-12 col-md-12 col-sm-12 padding-top60px">

                <div className='text-capitalize font20px'>Planning Modules</div>

                <div className="quick-view-table padding-top10px bottom20px quickview_i_table">
                    <table className="width100 table-rounded">
                        <thead>
                            <tr>
                                <th className="all_padding10px width50px font14px font-weight400px black-text-1 bg-white">Insurance Needs:</th>
                            </tr>
                        </thead>
                        <tbody className="quick_sub_table">
                            <tr>
                                <td className="text-left border-none-all blue_clr_important padding10px">To show insurance needs, run the calculation under "Smart Planner {'>'} Financial Plan {'>'} Insurance Calculator".</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }

    async function fetchAllApi() {
        fetchClientNotes()
    }

    useEffect(() => {
        fetchAllApi()
    }, [])


    return (
        <>
            <div>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', p: 1, bgcolor: 'transparent', borderRadius: 1, padding: 0 }} >
                    <div className='text-capitalize font20px'>Notes</div>
                    <div>
                        <Button className='btn-green'
                            onClick={() => addNote(1)}
                        >Add note</Button>
                    </div>
                </Box>

                {/*------------------NOTES TABLE ---------------*/}
                <div className="col-lg-12 col-md-12 col-sm-12">
                    <div className="quick-view-table padding-top5px bottom20px">
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="quick-view-table padding-top5px bottom20px">
                                <table striped='true' bordered='true' hover='true' className='width100'>
                                    <thead>
                                        <tr>
                                            <th className='width50'> </th>
                                            <th className="text-center"><div className='width50px font14px font-weight400px black-text-1'>Date</div></th>
                                            <th className="text-center"><div className='width50px font14px font-weight400px black-text-1'>Action</div></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {!clientNotes.length == 1 ?

                                            <tr>
                                                <td colSpan={3} className='height45px padding10px'>No record to show.</td>
                                            </tr>

                                            :

                                            clientNotes.map((clientNote, i) => (
                                                <tr key={i}>
                                                    <td>
                                                        <div>
                                                            <div className="print-selector d-none">{clientNote.note}</div>
                                                            <input

                                                                className="form-control width100 input-clean"
                                                                disabled={currentNoteIndex !== i}
                                                                value={clientNote.note}
                                                                onChange={(e) => {
                                                                    const newClientNotes = [...clientNotes];
                                                                    newClientNotes[i].note = e.target.value;
                                                                    setClientNotes(newClientNotes);
                                                                }}
                                                            />
                                                        </div>
                                                    </td>
                                                    <td><div>
                                                        {/* {clientNote.date} */}
                                                        <input

                                                            className="print_blue_color input-clean"
                                                            disabled
                                                            value={clientNote.date}
                                                        />
                                                    </div></td>
                                                    <td>
                                                        {currentNoteIndex === i ? (
                                                            <>
                                                                <IconButton onClick={() => updateNote(i, 1)}>
                                                                    <Check />
                                                                </IconButton>
                                                                <IconButton onClick={() => editNote(-1, 1)}>
                                                                    <Close />
                                                                </IconButton>
                                                            </>
                                                        ) : (<>
                                                            <IconButton onClick={() => editNote(i, 1)}>
                                                                <Edit />
                                                            </IconButton>
                                                            <IconButton onClick={() => deleteNoteData(i, clientNote.id, 1)}>
                                                                <Delete />
                                                            </IconButton>
                                                        </>)}
                                                    </td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* -------------------END OF CLIENT NOTES -------------------*/}


            <InvestmentComponent />
            <OutSideAssetComponent />
            <AccountDocComponent />
            <PlanningModuleComponent />

            {/* saving plan */}
            <div className='padding-top60px'>
                <div className='white-block'>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', p: 1, bgcolor: 'transparent', borderRadius: 1, padding: 0 }} >
                        <div className='text-capitalize font20px'></div>
                        {/* <th className="all_padding10px width50px font14px font-weight400px black-text-1 bg-white">Accumulation/Savings Plan:</th> */}
                        <div>
                            <Button className='btn-green'
                                onClick={() => addNote(2)}
                            >Add note</Button>
                        </div>
                    </Box>

                    {/*------------------SAVING TABLE ---------------*/}
                    <div className="col-lg-12 col-md-12 col-sm-12">
                        <div className="quick-view-table padding-top5px bottom20px">
                            <div className="col-lg-12 col-md-12 col-sm-12">
                                <div className="quick-view-table padding-top5px bottom20px">
                                    <table striped='true' bordered='true' hover='true' className='width100'>
                                        <thead>
                                            <tr>
                                                <th className='width50 font14px font-weight400px black-text-1 text-left'>Accumulation/Savings Plan: </th>
                                                <th className="text-center"><div className='width50px font14px font-weight400px black-text-1'>Date</div></th>
                                                <th className="text-center"><div className='width50px font14px font-weight400px black-text-1'>Action</div></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {!savingNotes.length == 1 ?

                                                <tr>
                                                    <td colSpan={3} className='height45px padding10px'>No record to show.</td>
                                                </tr>

                                                :

                                                savingNotes.map((savingNote, i) => (
                                                    <tr key={i}>
                                                        <td>
                                                            <div>
                                                                <div className="print-selector d-none">{savingNote.note}</div>
                                                                <input

                                                                    className="form-control width100 input-clean"
                                                                    disabled={savingNoteIndex !== i}
                                                                    value={savingNote.note}
                                                                    onChange={(e) => {
                                                                        const newSavingNotes = [...savingNotes];
                                                                        newSavingNotes[i].note = e.target.value;
                                                                        setSavingNotes(newSavingNotes);
                                                                    }}
                                                                />
                                                            </div>
                                                        </td>
                                                        <td><div>
                                                            {/* {clientNote.date} */}
                                                            <input

                                                                className="print_blue_color input-clean"
                                                                disabled
                                                                value={savingNote.date}
                                                            />
                                                        </div></td>
                                                        <td>
                                                            {savingNoteIndex === i ? (
                                                                <>
                                                                    <IconButton onClick={() => updateNote(i, 2)}>
                                                                        <Check />
                                                                    </IconButton>
                                                                    <IconButton onClick={() => editNote(-1, 2)}>
                                                                        <Close />
                                                                    </IconButton>
                                                                </>
                                                            ) : (<>
                                                                <IconButton onClick={() => editNote(i, 2)}>
                                                                    <Edit />
                                                                </IconButton>
                                                                <IconButton onClick={() => deleteNoteData(i, savingNote.id, 2)}>
                                                                    <Delete />
                                                                </IconButton>
                                                            </>)}
                                                        </td>
                                                    </tr>
                                                ))
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* end of saving plan */}


            {/* income plan */}
            <div className='padding-top60px'>
                <div className='white-block'>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', p: 1, bgcolor: 'transparent', borderRadius: 1, padding: 0 }} >
                        <div className='text-capitalize font20px'></div>
                        <div>
                            <Button className='btn-green'
                                onClick={() => addNote(3)}
                            >Add note</Button>
                        </div>
                    </Box>

                    {/*------------------INCOME TABLE ---------------*/}
                    <div className="col-lg-12 col-md-12 col-sm-12">
                        <div className="quick-view-table padding-top5px bottom20px">
                            <div className="col-lg-12 col-md-12 col-sm-12">
                                <div className="quick-view-table padding-top5px bottom20px">
                                    <table striped='true' bordered='true' hover='true' className='width100'>
                                        <thead>
                                            <tr>
                                                <th className='width50 font14px font-weight400px black-text-1 text-left'>Income Plan: </th>
                                                <th className="text-center"><div className='width50px font14px font-weight400px black-text-1'>Date</div></th>
                                                <th className="text-center"><div className='width50px font14px font-weight400px black-text-1'>Action</div></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {!incomeNotes.length == 1 ?

                                                <tr>
                                                    <td colSpan={3} className='height45px padding10px'>No record to show.</td>
                                                </tr>

                                                :

                                                incomeNotes.map((incomeNote, i) => (
                                                    <tr key={i}>
                                                        <td>
                                                            <div>
                                                                <div className="print-selector d-none">{incomeNote.note}</div>
                                                                <input

                                                                    className="form-control width100 input-clean"
                                                                    disabled={incomeNoteIndex !== i}
                                                                    value={incomeNotes.note}
                                                                    onChange={(e) => {
                                                                        const newIncomeNotes = [...incomeNotes];
                                                                        newIncomeNotes[i].note = e.target.value;
                                                                        setIncomeNotes(newIncomeNotes);
                                                                    }}
                                                                />
                                                            </div>
                                                        </td>
                                                        <td><div>
                                                            {/* {clientNote.date} */}
                                                            <input

                                                                className="print_blue_color input-clean"
                                                                disabled
                                                                value={incomeNote.date}
                                                            />
                                                        </div></td>
                                                        <td>
                                                            {incomeNoteIndex === i ? (
                                                                <>
                                                                    <IconButton onClick={() => updateNote(i, 3)}>
                                                                        <Check />
                                                                    </IconButton>
                                                                    <IconButton onClick={() => editNote(-1, 3)}>
                                                                        <Close />
                                                                    </IconButton>
                                                                </>
                                                            ) : (<>
                                                                <IconButton onClick={() => editNote(i, 3)}>
                                                                    <Edit />
                                                                </IconButton>
                                                                <IconButton onClick={() => deleteNoteData(i, incomeNote.id, 3)}>
                                                                    <Delete />
                                                                </IconButton>
                                                            </>)}
                                                        </td>
                                                    </tr>
                                                ))
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* end of income plan */}


            {/* estate plan */}
            <div className='padding-top60px'>
                <div className='white-block'>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', p: 1, bgcolor: 'transparent', borderRadius: 1, padding: 0 }} >
                        <div className='text-capitalize font20px'></div>
                        {/* <th className="all_padding10px width50px font14px font-weight400px black-text-1 bg-white">Accumulation/Savings Plan:</th> */}
                        <div>
                            <Button className='btn-green'
                                onClick={() => addNote(4)}
                            >Add note</Button>
                        </div>
                    </Box>

                    {/*------------------ESTATE TABLE ---------------*/}
                    <div className="col-lg-12 col-md-12 col-sm-12">
                        <div className="quick-view-table padding-top5px bottom20px">
                            <div className="col-lg-12 col-md-12 col-sm-12">
                                <div className="quick-view-table padding-top5px bottom20px">
                                    <table striped='true' bordered='true' hover='true' className='width100'>
                                        <thead>
                                            <tr>
                                                <th className='width50 font14px font-weight400px black-text-1 text-left'>Estate Plan: </th>
                                                <th className="text-center"><div className='width50px font14px font-weight400px black-text-1'>Date</div></th>
                                                <th className="text-center"><div className='width50px font14px font-weight400px black-text-1'>Action</div></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {!estateNotes.length == 1 ?

                                                <tr>
                                                    <td colSpan={3} className='height45px padding10px'>No record to show.</td>
                                                </tr>

                                                :

                                                estateNotes.map((estateNote, i) => (
                                                    <tr key={i}>
                                                        <td>
                                                            <div>
                                                                <div className="print-selector d-none">{estateNote.note}</div>
                                                                <input

                                                                    className="form-control width100 input-clean"
                                                                    disabled={estateNoteIndex !== i}
                                                                    value={estateNotes.note}
                                                                    onChange={(e) => {
                                                                        const newEstateNotes = [...estateNotes];
                                                                        newEstateNotes[i].note = e.target.value;
                                                                        setEstateNotes(newEstateNotes);
                                                                    }}
                                                                />
                                                            </div>
                                                        </td>
                                                        <td><div>
                                                            {/* {clientNote.date} */}
                                                            <input

                                                                className="print_blue_color input-clean"
                                                                disabled
                                                                value={estateNote.date}
                                                            />
                                                        </div></td>
                                                        <td>
                                                            {estateNoteIndex === i ? (
                                                                <>
                                                                    <IconButton onClick={() => updateNote(i, 4)}>
                                                                        <Check />
                                                                    </IconButton>
                                                                    <IconButton onClick={() => editNote(-1, 4)}>
                                                                        <Close />
                                                                    </IconButton>
                                                                </>
                                                            ) : (<>
                                                                <IconButton onClick={() => editNote(i, 4)}>
                                                                    <Edit />
                                                                </IconButton>
                                                                <IconButton onClick={() => deleteNoteData(i, estateNote.id, 4)}>
                                                                    <Delete />
                                                                </IconButton>
                                                            </>)}
                                                        </td>
                                                    </tr>
                                                ))
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ToastContainer />
            </div>
            {/* end of estate plan */}
        </>
    )
}

export default QuickViewDrawer